import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';

export const createComplaintStore = (preloadedState) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
      }),
  });

const store = createComplaintStore();

export { store };
export default store;
